import ReactDOM from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import useChallengeUIStore from "./store/challengeUIStore";
import { TfiLayoutLineSolid } from "react-icons/tfi";
import { useParams } from "react-router-dom";
import { useChallengeDetails } from "../../api/challenges/queryHooks";
import { decodeId, get_media_url } from "../../api/utils";

export const Details = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading, isError } = useChallengeDetails(id);

  if (isLoading || isError) return null;

  return (
    <>
      <h3 className="text-sm text-center mb-7">Challenge Information</h3>
      <div className="px-[35px] flex items-center gap-3 mb-4">
        <div>
          <img
            className="w-[38px] h-[38px] rounded-full border"
            src={get_media_url(data?.data?.dp_image)}
            alt="challengeimage"
          ></img>
        </div>
        <div>
          <h2 className="">{data.data.sponsored_details}</h2>
          <p className="text-[10px] italic">
            Sponsored by {data.data.sponsored_name}
          </p>
        </div>
      </div>
      {data?.data?.detail_info_description ? (
        <div
          className="px-[35px] mb-4"
          dangerouslySetInnerHTML={{
            __html: data.data.detail_info_description,
          }}
        ></div>
      ) : null}
      {/* <div className="px-[35px] text-[#AAAAAA] mb-4">
        <p className="text-xs">
          Try this challenge lorem ipsum dolor sit amet, conset sadipscing
          elitr, sed diam nonumy eirmod tempor.
        </p>
      </div>
      <div className="border-b border-[#444444] mx-[35px]"></div>
      <div className="px-[35px] my-4 text-center">
        <p className="text-xs">
          Try this challenge lorem ipsum dolor sit amet, conset sadipscing
          elitr, sed diam nonumy eirmod tempor.
        </p>
      </div>
      <div className="px-[35px] mb-4 text-center">
        <p className="text-xs text-[#FE0677]">
          Tip to Increase the number of Fan Cards:
        </p>

        <div className="mt-4">
          <p className="text-xs text-[#AAAAAA]">
            - Improve your Profile Score.
          </p>
          <p className="text-xs text-[#AAAAAA]">
            - Maintain the Post Streek till the challenge is active.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center gap-5">
        <div className="text-center">
          <h3>20%</h3>
          <p className="text-[9px]">Your Profile Score</p>
        </div>
        <div className="text-[#FE0677] text-xs">X</div>
        <div className="text-center">
          <h3>10</h3>
          <p className="text-[9px]">Likes On Your Post</p>
        </div>
        <div className="text-[#FE0677] text-xs">=</div>
        <div className="text-center">
          <h3>12</h3>
          <p className="text-[9px]">Total Entries</p>
        </div>
      </div>

      <div className="px-[35px] my-4 text-center">
        <p className="text-xs">
          The more Fan Cards you have, the more likely you are to be considered
          for the sponsorship.
        </p>
      </div> */}
    </>
  );
};

const ChallengeDetails = () => {
  const showDetails = useChallengeUIStore((state) => state.showDetails);
  const setShowDetails = useChallengeUIStore((state) => state.setShowDetails);

  return ReactDOM.createPortal(
    <AnimatePresence>
      {showDetails && (
        <motion.div
          className="fixed top-0 left-1/2 -translate-x-1/2 w-screen h-screen z-20"
          onClick={() => setShowDetails(false)}
        >
          <div
            className="bottom-0 left-0 absolute w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <motion.div
              className="bg-[#25262e] shadow-xl rounded-t-2xl overflow-y-auto hide-scrollbar max-h-[75vh]"
              initial={{ height: "0vh" }}
              animate={{ height: "fit-content" }}
              exit={{ height: "0vh" }}
              transition={{ duration: 0.2 }}
            >
              <div
                className="flex justify-center items-center py-4 cursor-pointer bg-[#25262e] hover:bg-[#23242c] rounded-t-2xl sticky top-0"
                onClick={() => setShowDetails(false)}
              >
                <TfiLayoutLineSolid className="fill-white" />
              </div>
              <Details />
              <div className="h-16 lg:h-0"></div>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default ChallengeDetails;
